import gen from '../gen'
import {immagaSuggestions} from "../../../api";
import uploadImage_5 from './uploadImage_5'
var ls = require('local-storage');
//
const state = {
  imaggaSuggestion: []
}

const getters = {
  imaggaSuggestion: state => state.imaggaSuggestion
}

const mutations = {

}

const actions = {
  //
  //
  async getImaggaSuggestions(state2, payload){ //server request
    return new Promise(async function (resolve) {
      //
      // console.log("[getImaggaSuggestions]", payload)
      //
      let url = payload.url
      let publicId = payload.publicId
      //
      state.imaggaSuggestion = []
      //
      await gen
        .actions
        .axiosGetReq(state, {
          url : immagaSuggestions,
          obj : {
            url,
            publicId
          }
        }).then((response)=>{
          //
          // console.log("[imaggaSuggestion]", response)


            let _data = response.data
            // console.log({_data})
            resolve(_data)

          //
          /* let imaggaSuggestions = response.data
           //
           state.imaggaSuggestion = gen.actions.arrayUnique(state.imaggaSuggestion.concat(imaggaSuggestions))
           state.keywords_uploadImage = state.imaggaSuggestion // added to text-field, now searches will concat
           //
           ls.set('imaggaSuggestions', //saving response in local storage => landmark
             JSON.stringify(state.imaggaSuggestion)); */
          //
        })
    })

  },
  //
}

export default{
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/uploadImage/imaggaAPI.js